import { render, staticRenderFns } from "./IconSortReset.vue?vue&type=template&id=10c79919&"
import script from "./IconSortReset.vue?vue&type=script&lang=js&"
export * from "./IconSortReset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports